import { NodeType } from '@amplify/amp-module';
import {
  ToggleMediaUploadPopup,
  ResetStore,
  SaveSelectedNode,
  UpdateSelectedNode,
  RemoveSelectedNode,
  ToggleDeleteConversationPopup,
  SetDeletedConversationId,
  ToggleSettingsPopup,
  ToggleConfigureMenuPopup,
  ToggleMultiDeletePopup,
  SetNodesForDeletion,
} from '@/constants/mutations';
import { ClearStore } from '@/constants/actions';
import {
  GetConfigureMenuPopupState,
  GetDeleteConversationPopupState,
  GetDeletedConversationId,
  GetSelectedNode,
  GetMediaUploadPopupState,
  GetSettingsPopupState,
} from '@/constants/getters';

const defaultState = () => {
  return {
    deleteConversationPopupState: false,
    configureMenuState: false,
    settingsPopupState: false,
    mediaUploadPopupState: false,
    multiDeletePopup: false,
    selectedNode: {},
    selectedSubNodeIds: null,
    availableMediaFiles: [], // all media files are available
    deletedConversationId: null,
    nodesForDeletion: null,
  };
};

export const state = defaultState;

export const mutations = {
  [ResetStore]: (state) => {
    Object.assign(state, defaultState());
  },

  // POPUP NODE HANDLING
  [SaveSelectedNode]: (state, { data, type }) => {
    state.selectedNode = data;

    if (type === NodeType.carousel) {
      state.availableMediaFiles = ['image'];
    } else if (type === NodeType.player) {
      state.availableMediaFiles = ['audio'];
    }
  },

  [UpdateSelectedNode]: (state, { data, key }) => {
    state.selectedNode[key] = data;
  },

  [RemoveSelectedNode]: (state) => {
    state.selectedNode = {};
    state.availableMediaFiles = [];
  },

  [SetNodesForDeletion]: (state, data) => {
    state.nodesForDeletion = data;
  },

  // MULTI DELETE POPUP
  [ToggleMultiDeletePopup]: (state, data) => {
    state.multiDeletePopup = data;
  },

  // MENU CONFIGURATION POPUP
  [ToggleConfigureMenuPopup]: (state, data) => {
    state.configureMenuState = data;
  },

  // MEDIA FILES POPUP
  [ToggleMediaUploadPopup]: (state, data) => {
    state.mediaUploadPopupState = data;
  },

  // DELETE CONVERSATION POPUP
  [ToggleDeleteConversationPopup]: (state, value) => {
    state.deleteConversationPopupState = value;

    if (!value) {
      state.deletedConversationId = null;
    }
  },

  [SetDeletedConversationId]: (state, id) => {
    state.deletedConversationId = id;
  },

  // AMP SETTINGS POPUP
  [ToggleSettingsPopup]: (state, data) => {
    state.settingsPopupState = data;
  },
};

export const actions = {
  [ClearStore]({ commit }) {
    commit(ResetStore);
  },
};

export const getters = {
  // MENU CONFIGURATION POPUP
  [GetConfigureMenuPopupState]: (state) => state.configureMenuState,

  // MEDIA FILES POPUP
  [GetMediaUploadPopupState]: (state) => state.mediaUploadPopupState,

  [GetSelectedNode]: (state) => state.selectedNode,

  // DELETE CONVERSATION POPUP
  [GetDeleteConversationPopupState]: (state) => state.deleteConversationPopupState,

  [GetDeletedConversationId]: (state) => state.deletedConversationId,

  // AMP SETTINGS POPUP
  [GetSettingsPopupState]: (state) => state.settingsPopupState,
};
